module.exports = __webpack_public_path__ + "static/media/tablet-landscape-flat.15d25ae1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/patient-hope/tablet-landscape-flat.png
// module id = 379
// module chunks = 0